// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UgY1","colBig":"styles_colBig__2Qpm6","colSmall":"styles_colSmall__1VEKj"};